<div class="wa-summary-modal">
  <button type="button" class="wa-summary-close" (click)="snooze()" aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>

  <div class="wa-summary-brand" aria-hidden="true">
    <span class="wa-summary-brand-dot"></span>
    <span>WhatsApp</span>
  </div>

  <h1 class="wa-summary-headline" mat-dialog-title>{{ copy.waPopupHeadline }}</h1>
  <p class="wa-summary-support">{{ copy.waPopupSupport }}</p>

  <div class="wa-summary-bubble" aria-label="Example Daily Insights message">
    <p class="wa-summary-bubble-label">Example message</p>
    <pre class="wa-summary-preview">{{ copy.waPopupPreview }}</pre>
  </div>

  <div class="wa-summary-form">
    <label class="wa-summary-field-label" for="wa-summary-phone-input">Mobile number</label>
    <div class="wa-summary-phone-row">
      <mat-select
        class="wa-summary-dial"
        panelClass="journey-phone-dial-panel"
        [(ngModel)]="dialCode"
        [disabled]="status === 'saving'"
        aria-label="Country code"
        disableOptionCentering>
        <mat-select-trigger>
          <span class="wa-summary-dial-trigger">{{ dialDisplay }}</span>
        </mat-select-trigger>
        <mat-option *ngFor="let c of countries" [value]="c.dialCode">
          {{ c.code }} {{ c.dialCode }} — {{ c.name }}
        </mat-option>
      </mat-select>
      <span class="wa-summary-phone-divider" aria-hidden="true"></span>
      <input
        id="wa-summary-phone-input"
        type="tel"
        class="wa-summary-input browser-default"
        [(ngModel)]="national"
        name="waSummaryNational"
        maxlength="14"
        placeholder="Mobile number"
        autocomplete="tel-national"
        inputmode="numeric"
        [attr.aria-invalid]="status === 'invalid'"
        [readonly]="status === 'saving'"
        (keydown.enter)="$event.preventDefault(); save()" />
    </div>
    <p class="wa-summary-error" *ngIf="status === 'invalid'">{{ copy.waPopupInvalid }}</p>
  </div>

  <div class="wa-summary-actions">
    <button type="button" class="wa-summary-secondary" (click)="snooze()" [disabled]="status === 'saving'">
      {{ copy.waPopupSecondary }}
    </button>
    <button
      type="button"
      class="wa-summary-primary"
      (click)="save()"
      [disabled]="!canSave">
      {{ status === 'saving' ? 'Saving…' : copy.waPopupCta }}
    </button>
  </div>
</div>
